<template>
  <div class="about">
    <p>Un site présentant quelques événements de la classe</p>
  </div>
</template>
